import {Component, OnInit, ChangeDetectionStrategy} from '@angular/core';

@Component({
    selector: 'mbnm-moulding-merch-dialog',
    templateUrl: './moulding-merch-dialog.component.html',
    styleUrls: ['./moulding-merch-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class MouldingMerchDialogComponent implements OnInit {

  constructor() { }

  public moulding:any;
  public hangerType = 'wire';

  ngOnInit() {
  }

}
